module.exports = __webpack_public_path__ + "static/media/circle-artesana.caeac02e.svg";